import React from 'react';
import { useTrackSection } from '../utils/useTrackSection';
const comparisonRows = [{
  situation: 'Tu cobro',
  without: 'Por sesión, irregular',
  with: 'Abono mensual el día 1-5'
}, {
  situation: 'Cancelaciones',
  without: 'Sin política clara',
  with: 'Reglamento firmado'
}, {
  situation: 'Ingresos',
  without: 'Impredecibles',
  with: 'Fijos desde el día 5'
}, {
  situation: 'Nuevos pacientes',
  without: 'Solo boca a boca',
  with: 'Sistema de captación activo'
}, {
  situation: 'Evoluciones',
  without: 'Sin plantilla, horas de trabajo',
  with: 'Registro en 1 página en 5 min'
}, {
  situation: 'Tu Instagram',
  without: 'Sin estrategia',
  with: '30 días de contenido listo'
}, {
  situation: 'El paciente que abandona',
  without: 'Sin sistema',
  with: 'Protocolo de re-enganche'
}, {
  situation: 'Tus honorarios',
  without: 'Los del mercado o menos',
  with: '30-50% más justificados'
}];
const blocks = [{
  num: '01',
  emoji: '💰',
  title: 'El Abono Blindado',
  desc: 'Cobro mensual adelantado + reglamento + contrato listo para usar.'
}, {
  num: '02',
  emoji: '📋',
  title: 'Evoluciones Rápidas',
  desc: 'Frases clínicas copy/paste. Registro de evolución en 5 minutos.'
}, {
  num: '03',
  emoji: '📱',
  title: 'WhatsApp que Retiene',
  desc: 'Scripts de seguimiento + mensajes de adherencia listos para enviar.'
}, {
  num: '04',
  emoji: '📸',
  title: 'Autoridad Digital',
  desc: '20 tipos de post + calendario de 30 días listo para publicar.'
}];
const assets = ['Planilla de Pagos', 'Calculadora de Honorarios', 'Reglamento', 'Contrato', 'Consentimiento Informado', 'Autorización de Imagen', '20 Stories Listos'];
export function ProBusiness() {
  useTrackSection('pro-business', 'Pro Business Section');
  return <section id="pro-business" className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(235,248,255) 0%, rgb(224,247,255) 15%, rgb(224,247,255) 85%, rgb(255,255,255) 100%)',
    fontFamily: 'var(--font-system)'
  }} data-id="element-223">
      <div className="mx-auto max-w-4xl" data-id="element-224">
        {/* Header */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-225">
          ¿Qué agrega{' '}
          <span style={{
          color: '#0077B6'
        }} data-id="element-226">
            el Método KINE-PRO™?
          </span>
        </h2>
        <p className="text-center text-sm text-gray-500 mx-auto max-w-xl m-0 mb-8" data-id="element-227">
          El sistema de cobro, gestión e identidad profesional que hace que tu
          consultorio esté a la altura de tu formación.
        </p>

        {/* Scroll hint mobile */}
        <p className="text-xs text-gray-400 text-center mb-2 sm:hidden flex items-center justify-center gap-1" data-id="element-228">
          <span data-id="element-229">👆</span> Deslizá para ver la tabla completa
        </p>

        {/* Comparison Table */}
        <div className="mb-8 overflow-x-auto rounded-xl shadow-sm touch-pan-x" style={{
        border: '1px solid rgba(0,119,182,0.20)',
        WebkitOverflowScrolling: 'touch'
      }} data-id="element-230">
          <div className="min-w-[560px] bg-white rounded-xl overflow-hidden" data-id="element-231">
            {/* Table Header */}
            <div className="grid grid-cols-3 border-b border-gray-100" data-id="element-232">
              <div className="px-4 py-3 text-xs font-bold text-gray-500 uppercase tracking-wide" data-id="element-233">
                Situación
              </div>
              <div className="px-4 py-3 text-xs font-bold text-gray-400 uppercase tracking-wide border-l border-gray-100 text-center" data-id="element-234">
                ❌ Sin Método KINE-PRO
              </div>
              <div className="px-4 py-3 text-xs font-bold uppercase tracking-wide border-l border-gray-100 text-center" style={{
              color: '#0077B6'
            }} data-id="element-235">
                ✅ Con Método KINE-PRO
              </div>
            </div>

            {/* Table Rows */}
            {comparisonRows.map((row, i) => <div key={row.situation} className={`grid grid-cols-3 ${i < comparisonRows.length - 1 ? 'border-b border-gray-100' : ''}`} data-id="element-236">
                <div className="px-4 py-3 text-xs font-bold text-gray-900" data-id="element-237">
                  {row.situation}
                </div>
                <div className="px-4 py-3 text-xs text-gray-500 border-l border-gray-100 bg-gray-50 text-center" data-id="element-238">
                  {row.without}
                </div>
                <div className="px-4 py-3 text-xs text-gray-900 border-l border-gray-100 text-center" style={{
              backgroundColor: 'rgba(0,119,182,0.05)'
            }} data-id="element-239">
                  {row.with}
                </div>
              </div>)}
          </div>
        </div>

        {/* Blocks */}
        <div className="bg-white rounded-xl overflow-hidden shadow-sm mb-4" style={{
        border: '1px solid rgba(0,119,182,0.20)'
      }} data-id="element-240">
          {/* Header */}
          <div className="px-5 py-3" style={{
          backgroundColor: '#0077B6'
        }} data-id="element-241">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-242">
              🏆 MÉTODO KINE-PRO™ INCLUYE:
            </h3>
          </div>

          {/* List */}
          <div className="divide-y divide-gray-100" data-id="element-243">
            {blocks.map(block => <div key={block.num} className="flex items-center gap-4 px-5 py-3" data-id="element-244">
                {/* Número */}
                <span className="shrink-0 text-lg font-black w-8 text-center" style={{
              color: 'rgba(0,119,182,0.30)'
            }} data-id="element-245">
                  {block.num}
                </span>

                {/* Emoji + Contenido */}
                <div className="flex-1 min-w-0" data-id="element-246">
                  <span className="block text-sm font-black text-gray-900" data-id="element-247">
                    {block.emoji} {block.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-248">
                    {block.desc}
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        {/* Assets */}
        <div className="rounded-xl px-5 py-4" style={{
        backgroundColor: 'rgba(0,119,182,0.05)',
        border: '1px solid rgba(0,119,182,0.20)'
      }} data-id="element-249">
          <p className="text-xs font-bold uppercase tracking-widest m-0 mb-3" style={{
          color: '#0077B6'
        }} data-id="element-250">
            📊 Assets incluidos:
          </p>
          <div className="flex flex-wrap gap-2" data-id="element-251">
            {assets.map(asset => <span key={asset} className="text-[11px] font-bold bg-white rounded-full px-3 py-1" style={{
            color: '#0077B6',
            border: '1px solid rgba(0,119,182,0.20)'
          }} data-id="element-252">
                {asset}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}